import { EntityType } from './entity-type';

export const TOTAL_ENTITIES = 'totalEntities';

/**
 * Checks if Entity is Checked in the current user catalog
 */
export function isEntityActive(targetEntity: EntityType): boolean {
  const totalEntities = JSON.parse(localStorage.getItem(TOTAL_ENTITIES));
  const _isEntityChecked = ({ entityObj }) => entityObj.name.toLowerCase() === targetEntity && entityObj.isChecked;
  return totalEntities?.some(_isEntityChecked);
}

export const isTenancyActive = () => isEntityActive(EntityType.Tenancy);

export const isSaleCompActive = () => isEntityActive(EntityType.SaleComp);

export const isTIMActive = () => isEntityActive(EntityType.Tim);
